<template>
  <div class="all-settings">
    <base-header class="pb-6">
      <b-row class="py-3">
        <b-col lg="6" cols="7">
          <h2 class="text-xl d-inline-block mb-0">All Settings</h2>
          <p class="text-muted">All settings require Credit Manager's approval before being applied.</p>
        </b-col>
      </b-row>
    </base-header>
    <b-container fluid class="mt--6">
      <el-tabs>
        <el-tab-pane label="Collection">
          <CollectionSettings />
        </el-tab-pane>
        <el-tab-pane label="Funds Management">
          <FundsManagementSettings />
        </el-tab-pane>
        <el-tab-pane label="Loan">
          <LoanSettings />
        </el-tab-pane>
        <el-tab-pane label="Credit Loan Type">
          <CreditLoanTypeSettings />
        </el-tab-pane>
      </el-tabs>
    </b-container>
  </div>
</template>
<script>
import { Tabs, TabPane } from 'element-ui'
import CollectionSettings from '@/views/AllSettings/SettingsPages/CollectionSettings'
import FundsManagementSettings from '@/views/AllSettings/SettingsPages/FundsMgmtSettings'
import LoanSettings from '@/views/AllSettings/SettingsPages/LoanSettings'
import CreditLoanTypeSettings from '@/views/AllSettings/SettingsPages/CreditLoanTypeSettings'

export default {
  components: {
    CollectionSettings,
    FundsManagementSettings,
    LoanSettings,
    CreditLoanTypeSettings,
    [Tabs.name]: Tabs,
    [TabPane.name]: TabPane,
  }
}
</script>